import React, { useRef, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useChangePasswordContext } from "../contexts/ChangePasswordContext";
import { useErrorContext } from "../contexts/ErrorContext";
import { useLoginContext } from "../contexts/LoginContext";
import { useMsgContext } from "../contexts/MsgContext";
import "../css/formulario.css";
import { Get } from "../Utils/Helpers";
import { FetchResponse } from "../Utils/Types";

const ChangePasswordForm = () => {
	const { cuil } = useLoginContext();
	const { setErrorMsg } = useErrorContext();
	const { setMsg } = useMsgContext();
	const { previousPass, setPreviousPass, previousPassHashed, newPass, setNewPass, newPassHashed, setCambiandoPass } =
		useChangePasswordContext();

	const [repitPass, setRepitPass] = useState("");

	const refPreviousPass = useRef<HTMLInputElement>(null);
	const refNewPass = useRef<HTMLInputElement>(null);
	const refRepitNewPass = useRef<HTMLInputElement>(null);

	const _datosValidos = (): boolean => {
		if (previousPass.length < 4) {
			setErrorMsg("La contraseña anterior no es válida. Por favor, vuelva a escribirla he intente nuevamente.");
			refPreviousPass.current?.select();
			return false;
		}

		if (newPass.length < 4) {
			setErrorMsg("La nueva contraseña no es válida. Por favor, vuelva a escribirla he intente nuevamente.");
			refNewPass.current?.select();
			return false;
		}

		if (repitPass.length < 4) {
			setErrorMsg(
				"La repetición de la contraseña no es válida. Por favor, vuelva a escribirla he intente nuevamente."
			);
			refNewPass.current?.select();
			return false;
		}

		if (newPass !== repitPass) {
			setErrorMsg(
				"La nueva contraseña y su repetición no coinciden. Por favor, vuelva a escribirlas he intente nuevamente."
			);
			refNewPass.current?.select();
			return false;
		}

		return true;
	};

	const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();

		if (!_datosValidos()) return;

		const result: FetchResponse = await Get(`/CambiarClave/${cuil}/${previousPassHashed}/${newPassHashed}`);

		if (result.error) {
			setErrorMsg(result.ErrorMsg);
			refPreviousPass.current?.select();
			return;
		}

		if (!result.resultados) {
			setErrorMsg(
				"Hubo un problema al querer cambiar la clave. Por favor, vuelva a intentar dentro de unos minutos."
			);
			return;
		}

		setMsg(`¡El cambio de contraseña fué todo un éxito! La próxima vez ya va a utilizarla para acceder.`);

		goBack();
	};

	const goBack = () => {
		setPreviousPass("");
		setNewPass("");
		setRepitPass("");
		setCambiandoPass(false);
	};

	const handlePreviousPassOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setPreviousPass(v.target.value);
	};

	const handleNewPassOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setNewPass(v.target.value);
	};

	const handleRepitPassOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setRepitPass(v.target.value);
	};

	return (
		<Col className='formulario-contenedor'>
			<div className='formulario'>
				<Form>
					<Form.Group className='mb-3' controlId='formBasicPassword'>
						<Form.Label>Contraseña Actual</Form.Label>
						<Form.Control
							type='password'
							placeholder='Contraseña Actual'
							className='clave-input'
							value={previousPass}
							onChange={handlePreviousPassOnChange}
							ref={refPreviousPass}
							autoFocus
						/>
					</Form.Group>

					<Form.Group className='mb-3' controlId='formBasicPassword'>
						<Form.Label>Contraseña</Form.Label>
						<Form.Control
							type='password'
							placeholder='Nueva Contraseña'
							className='clave-input'
							value={newPass}
							onChange={handleNewPassOnChange}
							ref={refNewPass}
						/>
					</Form.Group>
					<Form.Group className='mb-3' controlId='formBasicPassword'>
						<Form.Label>Repetir Contraseña</Form.Label>
						<Form.Control
							type='password'
							placeholder='Repita su Contraseña'
							className='clave-input'
							value={repitPass}
							onChange={handleRepitPassOnChange}
							ref={refRepitNewPass}
						/>
					</Form.Group>
					<Button variant='primary' type='submit' size='lg' onClick={handleSubmit} disabled={false}>
						Confirmar Datos
					</Button>
					<Button
						variant='link'
						className='btn-registrarse'
						onClick={(e) => {
							e.preventDefault();
							goBack();
						}}
					>
						Cancelar
					</Button>
				</Form>
			</div>
		</Col>
	);
};

export default ChangePasswordForm;
